interface SwirlIconProps {
  size?: number;
  light?: boolean;
  stroke?: string;
  fill?: string;
  className?: string;
}

const SwirlIcon = ({ size = 40, light, stroke, fill, className = "" }: SwirlIconProps) => {
  const strokeColor = stroke ?? (light ? "#fff" : "var(--amb-orange)");
  const fillColor = fill ?? (light ? "#fff" : "var(--amb-orange)");

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
    >
      <path
        d="M52 8 A42 42 0 1 1 18 78"
        stroke={strokeColor}
        strokeWidth="15"
        fill="none"
        strokeLinecap="round"
      />
      <path d="M56 52 L84 74 L60 82 Z" fill={fillColor} />
      <rect x="30" y="90" width="48" height="12" rx="6" fill={fillColor} />
    </svg>
  );
};

export default SwirlIcon;
